module.exports = __webpack_public_path__ + "img/symmetry-vertical.3e74d318.svg";